<template lang="pug">
.v-field-page-select.field-page-select
	h1.field-page-select__title(v-if="field.placeholder" ) {{ field.placeholder }}
	.field-page-select__items
		.field-page-select__item.flc(v-for="(option, index) in field.options" :key="option.value + '-' + index")
			label.field-page-select__label
				input.field-page-select__input(
					type="radio"
					:value="option.value"
					v-model="localValue"
					@change="handleInput"
					:id="uniqueId")
				.field-page-select__wrap
					span.field-page-select__text(v-if="option.text" ) {{ option.text }}
					span.field-page-select__count(v-if="option.count" ) {{ option.count }}
</template>

<script>
import uniqueId from '../scripts/helpers/uniqueId.js';

export default {
	props: {
		field: {
			type: Object,
			required: true,
			default: null
		},

		modelValue: {
			type: [Object, String, Number],
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			uniqueId: uniqueId('field-')
		};
	},

	watch: {
		modelValue() {
			this.updateLocalValue();
		}
	},

	created() {
		this.updateLocalValue();
	},

	methods: {
		updateLocalValue() {
			this.localValue = this.modelValue;
		},

		handleInput() {
			this.$emit('update:model-value', this.localValue);
		}
	},

};
</script>
